export default "__VITE_PUBLIC_ASSET__d5468139__"